export default "__VITE_ASSET__v85YDEXY__"